<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <span class="pull-left">
          <h2 class="text-purple-manax m-0 pl-3 title-section" *ngIf="!agreementsInvoicing">Contratos</h2>
          <h2 class="text-purple-manax m-0 pl-3 title-section" *ngIf="agreementsInvoicing">Generar Facturacion</h2>
          <div class="text-purple-manax pr-5" *ngIf="agreementsInvoicing" style="width: 100%;">
            <span class="pull-left px-4">
              Indique <b>rango de fechas</b> y <b>cliente</b> para listar <b>contratos</b>.
              Seleccione cuales van a ser incluidos en la factura.
            </span>
          </div>
        </span>
        <span class="pull-right pt-1 pb-4">
          <div class="text-purple-manax" n style="width: 100%;" *ngIf="agreementsInvoicing">
            <span class="pull-right pt-1 pb-4 pr-3" *ngIf="selection.some || selection.all">
              <button mat-raised-button type="button" class="btn btn-manax p-2" (click)="openCreateAgreementsInvoice()">
                <i class="material-icons">paid</i> Generar Factura
              </button>
            </span>
          </div>
        </span>

        <table class="table table-hover m-0 align-top" stickyHeader stickyFooter>

          <thead class="text-manax">
            <tr>

              <!-- All -->
              <th class="p-0 pl-2" *ngIf="agreementsInvoicing">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                      [checked]="selection.all">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </th>

              <!-- PC -->
              <th class="d-none d-md-table-cell align-top" style="height: 90px; position: relative;" width="170px">
                Fecha<br>
                <input type="date" class="filter small" [(ngModel)]="filter.filters.taskStartDate"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" *ngIf="agreementsInvoicing"
                  style="max-width: 120px; position: absolute; top: 37px; left: 0px;" /><br>
                <input type="date" class="filter small" [(ngModel)]="filter.filters.taskEndDate"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" *ngIf="agreementsInvoicing"
                  style="max-width: 120px; position: absolute; top: 60px; left: 0px;" />
              </th>
              <th class="d-none d-md-table-cell align-top">
                Cliente<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.client"
                  placeholder="Buscar por Cliente…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>
              <th class="d-none d-md-table-cell align-top">
                Titulo<br>
              </th>
              <th class="d-none d-md-table-cell align-top">
                Categoría<br>
              </th>
              <th class="d-none d-md-table-cell align-top">
                Servicios<br>
              </th>
              <th class="d-none d-md-table-cell align-top text-right">
                Total {{curr}}<br>
              </th>

              <!-- All -->
              <th class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">

                  <button mat-menu-item (click)="clearFilter()">
                    <span>Limpiar Filtros</span>
                  </button>
                </mat-menu>

              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let agreement of agreements" [class.text-danger]="agreement.isDeleted" class='cursor-pointer'>

              <!-- All -->
              <td class="p-0 pl-2" (click)="$event.stopPropagation();" *ngIf="agreementsInvoicing">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection(agreement._id)"
                      [checked]="selection.all || selection[agreement._id]">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </td>

              <!-- PC -->
              <td class="d-none d-md-table-cell">{{agreement.date | date:'dd/MM/yyyy'}}</td>
              <td class="d-none d-md-table-cell">{{agreement.client?.lastname}} {{agreement.client?.firstname}}</td>
              <td class="d-none d-md-table-cell">{{agreement.title}}</td>
              <td class="d-none d-md-table-cell">{{agreement.category?.name}}</td>
              <td class="d-none d-md-table-cell">{{agreement.tasks?.length || 0}}</td>

              <td class="d-none d-md-table-cell text-right">{{agreement.total | money }}</td>

              <!-- Mobile -->
              <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <div class="col-12">
                  <div class="row">
                    <div class="col-8 col-sm-6">
                      <div class="row mb-2 pr-3">
                        <b class="bold-item">
                          {{agreement.date | date:'dd/MM/yyyy'}}
                        </b>
                      </div>
                      <div class="row mb-2 pr-3">
                        <b class="bold-item">
                          {{agreement.client.firstname}} {{agreement.client.lastname}}
                        </b>
                      </div>
                      <div class="row mb-2 pr-3">
                        Emisión: {{agreement.date | date:'dd/MM/yyyy'}}
                      </div>
                      <div class="row pr-3">
                        Vencimiento: {{agreement.dueDate | date:'dd/MM/yyyy'}}
                      </div>
                    </div>
                    <div class="col-4 col-sm-6 d-flex flex-column align-items-center justify-content-center p-0">
                      <div class="row mb-2">
                        Total: {{agreement.total | money: { needSymbol:true } }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <!-- All -->
              <td class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openCreateAgreementInvoice(agreement)">
                    <span>Facturar</span>
                  </button>
                </mat-menu>
              </td>
            </tr>

            <!-- All  -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                  mas</button>
              </td>
            </tr>
            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center" >
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="text-purple-manax">
            <tr *ngIf="!loading">
              <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ agreements?.length }} contratos</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>